// 将日期格式化为yyyy-mm-dd的方法
function formatDate(date) {
  let d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}
// 时间跨度在3个月内
function betweenThreeMonth(beginTime, endTime) {
  if (!!!beginTime || !!!endTime) {
    return false;
  }
  // 如果开始时间大于结束时间则互换
  if (new Date(beginTime).getTime() > new Date(endTime).getTime()) {
    let transfer1 = JSON.parse(JSON.stringify(beginTime));
    let transfer2 = JSON.parse(JSON.stringify(endTime));
    beginTime = transfer2;
    endTime = transfer1;
  }

  let time1 = new Date(beginTime).getTime();
  let time2 = new Date(endTime).getTime();
  if (beginTime == '') {
    return false;
  }
  if (endTime == '') {
    return false;
  }
  if (time1 > time2) {
    return false;
  }

  //判断时间跨度是否大于3个月
  let arr1 = beginTime.split('-');
  let arr2 = endTime.split('-');
  arr1[1] = parseInt(arr1[1]);
  arr1[2] = parseInt(arr1[2]);
  arr2[1] = parseInt(arr2[1]);
  arr2[2] = parseInt(arr2[2]);
  let flag = true;
  if (arr1[0] == arr2[0]) {//同年
    if (arr2[1] - arr1[1] > 3) { //月间隔超过3个月
      flag = false;
    } else if (arr2[1] - arr1[1] == 3) { //月相隔3个月，比较日
      if (arr2[2] > arr1[2]) { //结束日期的日大于开始日期的日
        flag = false;
      }
    }
  } else { //不同年
    if (arr2[0] - arr1[0] > 1) {
      flag = false;
    } else if (arr2[0] - arr1[0] == 1) {
      if (arr1[1] < 10) { //开始年的月份小于10时，不需要跨年
        flag = false;
      } else if (arr1[1] + 3 - arr2[1] < 12) { //月相隔大于3个月
        flag = false;
      } else if (arr1[1] + 3 - arr2[1] == 12) { //月相隔3个月，比较日
        if (arr2[2] > arr1[2]) { //结束日期的日大于开始日期的日
          flag = false;
        }
      }
    }
  }
  return flag
}

export default {
  formatDate,
  betweenThreeMonth
}



// WEBPACK FOOTER //
// ./src/utils/dateUtil.js